import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
var RubriqBillingHistory = function RubriqBillingHistory() {
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("table", {
    className: "table table-striped table-rubriq"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Date')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Date"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('curie.detail'),
    className: "d-none d-sm-table-cell"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.detail"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('Amount')
  }, /*#__PURE__*/React.createElement(T, {
    source: "Amount"
  })), /*#__PURE__*/React.createElement("th", {
    "aria-label": t('curie.receipt')
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.receipt"
  }))))));
};
export default RubriqBillingHistory;